//src/components/api/citiesApi.js

import { authFetch } from "./api";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export const getCities = async () => {
  const res = await authFetch(`${BASE_URL}/api/cities/`);
  return res.json();
};